





























































import { coordinatesRefresh, localesPicker, locationPicker } from '@/constants/settings';
import { GeolocationCoordinates, GeolocationDetails } from '@/types/geolocation';
import { Homey } from '@/types/homey';
import { SettingsComponent } from '@/types/settings';
import { User } from '@/types/user';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SettingsList extends Vue {
    localesPicker: SettingsComponent = localesPicker;
    locationPicker: SettingsComponent = locationPicker;
    coordinatesRefresh: SettingsComponent = coordinatesRefresh;

    @Prop() private locale!: string;
    @Prop() private weatherLocation!: GeolocationDetails;
    @Prop() private homeyGeoCoordinates!: GeolocationCoordinates;
    @Prop() private isWeatherLocationLoaded!: boolean;
    @Prop() private isHomeyGeoCoordinatesLoaded!: boolean;
    @Prop() private isLoadingHomeyGeoCoordinates!: boolean;
    @Prop() private user!: User;
    @Prop() private homey!: Homey;

}
